import { useDispatch, useSelector } from 'react-redux';
import { logoutAway } from '../../../appRedux/actions/UserAuth';
import { useIdleTimer } from 'react-idle-timer';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getConfigs } from '../../../appRedux/actions';

export const IddleComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { configs } = useSelector((state) => state.configs);

  useEffect(() => {
    dispatch(getConfigs());
  }, [dispatch]);

  const timeout = (configs?.abscenceTime?.idleTime || 300) * 1000;

  const onIdle = async () => {
    await dispatch(logoutAway());
    navigate('/quick-login');
  };

  const { start, pause } = useIdleTimer({
    onIdle,
    timeout,
    throttle: 500,
    startManually: true,
  });

  const isOnAuthPage = ['/quick-login', '/', '/login', '/forgot-password'].includes(location.pathname);

  useEffect(() => {
    if (isOnAuthPage) {
      pause();
    } else {
      start();
    }
  }, [isOnAuthPage, start, pause]);

  return null;
};
